import React, { useRef, useState } from 'react'
import UEH_color_logo from "../assets/images/brands/UEH-color-logo.svg"
import UIT_color_logo from "../assets/images/brands/UIT-color-logo.svg"
import TDT_color_logo from "../assets/images/brands/TDT-color-logo.svg"
import HUTECH_color_logo from "../assets/images/brands/HUTECH-color-logo.svg"
import VANLANG_color_logo from "../assets/images/brands/vanlang-color-logo.svg"
import USTH_color_logo from "../assets/images/brands/USTH-color-logo.svg"
import FPT_color_logo from "../assets/images/brands/FPT-color-logo.svg"
import VNU_color_logo from "../assets/images/brands/VNU-color-logo.svg"
import PTIT_color_logo from "../assets/images/brands/PTIT-color-logo.svg"
import BK_color_logo from "../assets/images/brands/BK-color-logo.svg"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../redux/language/selector'
import { PrimaryButton } from './StyledButtons'
import ModalContactDiscussionForm from './ModalContactDiscussionForm';

const IndustriesImageContainer = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);

    const modalDiscussionRef = useRef(null);

    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };

    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='col-sm-12 pt-100 pb-50 px-md-0'>
            {language === "en" ?
                <p className='font-42 font-weight-semi-bold text-center text-white'>Leading <span className='text-primary-orange'>organizations and brands </span>rely on Qrypto</p>
                :
                <p className='font-weight-semi-bold font-42 text-center text-white'>
                    <span className='text-primary-orange'>Các tổ chức</span> và <span className='text-primary-orange'>thương hiệu</span> hàng đầu tin tưởng vào Qrypto
                </p>
            }
            <p className='text-center text-white pt-20 pb-50'>
                {t('home-page.organizations.sub-title')}
            </p>
            <div className='image-container'>
                <div className='image-container_list'>
                    <img src={UEH_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={UIT_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={TDT_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={HUTECH_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={VANLANG_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={USTH_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={FPT_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={VNU_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={PTIT_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={BK_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                </div>
                <div className='image-container_list'>
                    <img src={UEH_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={UIT_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={TDT_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={HUTECH_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={VANLANG_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={USTH_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={FPT_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={VNU_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={PTIT_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                    <img src={BK_color_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-150' />
                </div>
            </div>
            <div className='flex justify-center pt-50'>
                <PrimaryButton 
                onClick={() => setModalDiscussionOpen(true)}
                >{t('button.schedule-discussion')}</PrimaryButton>
            </div>
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
        </div>
    )
}

export default IndustriesImageContainer